(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogDetailController', PvlogDetailController);

    PvlogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pvlog'];

    function PvlogDetailController($scope, $rootScope, $stateParams, previousState, entity, Pvlog) {
        var vm = this;

        vm.pvlog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:pvlogUpdate', function(event, result) {
            vm.pvlog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
